<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {
  }
}
</script>

<style>
  @import './assets/reset.css';
  @import './assets/sms.css';
  @import './assets/index.scss'
</style>
